import React from "react";

const Jazzcash = () => {
  return <div>Jazzcash</div>;
};

export default Jazzcash;
